module.exports = __webpack_public_path__ + "static/media/25.6205cbb6.jpg";